import { useQuery } from "@tanstack/react-query";
import { ProductGroup } from "../../resbutler-utils/types/product";
import { getConfigUI } from "../init";
import { fetchStorageJson } from "./storageJson";

const useProductGroupsStorage = (useCacheBuster = true) => {
  async function loadProductGroups() {
    const { client, config } = getConfigUI();
    return fetchStorageJson<ProductGroup[]>(`https://storage.googleapis.com/${config.publicStorageBucket}/${client}/productData/productGroups.json`, useCacheBuster);
  }

  const { isLoading, data: productGroups = [] } = useQuery<ProductGroup[]>({
    queryKey: ["product-groups"],
    enabled: true,
    queryFn: () => loadProductGroups(),
    staleTime: 30 * 60 * 1000, // 30 minutes
    gcTime: 60 * 60 * 1000, // 60 minutes
  });

  return [isLoading, productGroups] as [boolean, ProductGroup[]];
};

export default useProductGroupsStorage;
